import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import CambioPassword from './Componentes/CambioPassword';

export default function CambiarPassword() {

    return (
        <MainContent component={ <CambioPassword /> } titulo='Cambiar Contraseña' />        
    );

};